import React from 'react';
import styled from 'styled-components';

import LinedTitle from '../components/LinedTitle';
import { Container, CardImg, CardText, CardBody, Row, Col } from 'reactstrap';
import { COLORS } from '../constants/style';
import moment from 'moment';
import { Link } from 'gatsby';
import ReadMore from '../components/ReadMore';

const EdcellentInsight = styled.section`
  padding-top: 80px;
  padding-bottom: 80px;
  background: ${COLORS.lightGray};

  #see-all-card {
    flex: 1;
    min-height: 300px;

    .card-body {
      height: 100%;
      background: url('/img/book-bg.jpg');
      position: relative;

      &:before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        background: url('/img/book-bg.jpg');
        filter: brightness(25%);
      }

      .see-all-card-content {
        height: 100%;
        width: 100%;
        position: relative;
        border: solid 1px ${COLORS.darkGold};
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;

        h2 {
          letter-spacing: 1px;
          line-height: 1.3;
          font-weight: 900;
          color: ${COLORS.darkGold};
        }
      }
    }
  }

  .card-link:hover {
    opacity: 0.95;
    .blog-title {
      color: ${COLORS.darkGold};
    }
    .readmore-text {
      font-weight: 900;
    }
  }

  .blog-card-img {
    height: 300px;
    width: 100%;
    object-fit: cover;
    filter: brightness(90%);
  }

  .blog-date {
    color: ${COLORS.darkGold};
    margin-bottom: 1em;
  }

  .blog-title {
    color: ${COLORS.textMain};
    font-weight: 900;
  }

  .blog-desc {
    color: ${COLORS.darkGray};
    text-align: justify;
  }
`;

const FeaturedBlogs = ({ isHome, posts, ...rest }) => {
  if (posts.length === 0) return null;

  return (
    <EdcellentInsight id="edcellent-insights" {...rest}>
      <Container>
        {isHome ? (
          <LinedTitle wing>The Edcellent Insights</LinedTitle>
        ) : (
          <>
            <h4 className="text-center mb-4 font-weight-bold text-uppercase letter-spaced-1">
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.facebook.com/EdcellentEducation/"
                className="styless-link"
              >
                Edcellent Blogs
              </a>
            </h4>
          </>
        )}
        <Row>
          {posts.map(
            ({
              node: { id, title, shortDescription, featuredImage, slug, meta },
            }) => (
              <Col key={id} md="6" lg="4" className="px-3 pb-4 d-flex ">
                <Link
                  to={`/blog/${slug}`}
                  className="card-link card border-0 rounded-0 text-decoration-none"
                >
                  <CardImg
                    {...featuredImage.sizes}
                    top
                    alt={`${title} featured image`}
                    className="blog-card-img rounded-0"
                  />
                  <CardBody className="flex-fill">
                    <div className="blog-date">
                      {moment(meta.createdAt).format('MMM Do, YYYY')}
                    </div>
                    <h3 className="blog-title">{title}</h3>
                    <CardText className="blog-desc">
                      {shortDescription}
                    </CardText>
                    <ReadMore url={`/blog/${slug}`} />
                  </CardBody>
                </Link>
              </Col>
            )
          )}
          {isHome ? (
            <Col md="6" lg="4" className="px-3 pb-4 d-flex ">
              <Link
                id="see-all-card"
                to={'/content#edcellent-insights'}
                className="card-link card border-0 rounded-0 text-decoration-none"
              >
                <CardBody className="flex-fill">
                  <div className="see-all-card-content">
                    <h2>More Edcellent Insights</h2>
                  </div>
                </CardBody>
              </Link>
            </Col>
          ) : null}
        </Row>
        {isHome ? '' : <hr className="m-0" />}
      </Container>
    </EdcellentInsight>
  );
};

export default FeaturedBlogs;
